import { queryOptions } from '@tanstack/react-query';

import { getMinimumVersionRequest } from './system.requests';

export const getMinimumVersionOptions = () =>
  queryOptions({
    queryFn: () => getMinimumVersionRequest(),
    queryKey: ['minimum-version'],
  });
